// @generated by web/tools/codegen — DO NOT EDIT

import type { MessageKeys } from './messages_gen';

/**
 * The ui-strings keys `web/manifests/routes.yaml`'s `title:` column places
 * in a route's static `handle` — the mobile band's title for every page
 * whose title is a STATIC fact rather than loader data.
 *
 * DERIVED from the same overlay walk that emits the handles, so the roster
 * and the handles cannot name different sets. The `satisfies` is the
 * compile-time half: a key the catalog does not hold fails to typecheck
 * HERE, in the generated file, rather than rendering as its own id on a
 * phone.
 */
export const PAGE_BAND_TITLE_KEYS = [
  'conversations.title',
  'inquiry.title',
  'pageTitles.district',
  'pageTitles.estate',
  'pageTitles.listing',
  'pageTitles.listingEditSection',
  'pageTitles.listingEditor',
  'pageTitles.myListings',
  'settings.title',
  'support.title',
] as const satisfies readonly MessageKeys<''>[];

/** One of {@link PAGE_BAND_TITLE_KEYS}. */
export type PageBandTitleKey = (typeof PAGE_BAND_TITLE_KEYS)[number];

/**
 * Narrow a route match's `handle.title`, exactly as `isPageChrome` narrows
 * its `handle.chrome`: React Router types `handle` as `unknown`, so the
 * shell owns the narrowing — and a value outside the roster must THROW
 * rather than render, because a band showing a raw message id is the same
 * defect as a band showing nothing.
 */
export function isPageBandTitleKey(value: unknown): value is PageBandTitleKey {
  return (PAGE_BAND_TITLE_KEYS as readonly unknown[]).includes(value);
}
